import { i18nService } from '@/services/i18n-service';

import { AGREEMENT_PREFIX, ALLIANCE_PREFIX, AMENDMENT_PREFIX, LEAD_PREFIX, OBLIGATION_PREFIX, TASK_PREFIX } from './router-prefixes.constants';

export const ROUTE_DATA = {
    ACCOUNT_PAGE: { name: 'account', path: 'account' },
    ADVANCED_SEARCH: { name: 'search', path: 'search' },
    AGREEMENT_HUB_PAGE: { name: 'agreement-hub', path: i18nService.t('AGREEMENT.LOW.SING'), alias: ['agreement'] },
    AGREEMENT_HUB_PAGE_BOARD: { name: 'agreement-hub-board', path: `${i18nService.t('AGREEMENT.LOW.SING')}-hub/:id`, alias: ['agreements/:id'] },
    AGREEMENT_OVERVIEW_PAGE: {
        name: 'agreement-overview',
        path: `${AGREEMENT_PREFIX}-:id`,
        alias: ['agreement/:id', `${i18nService.t('AGREEMENT.LOW.SING')}/:id`]
    },
    ALLIANCE_HUB_PAGE: { name: 'alliance-hub', path: i18nService.t('ALLIANCE.LOW.SING'), alias: ['alliance'] },
    ALLIANCE_HUB_PAGE_BOARD: { name: 'alliance-hub-board', path: `${i18nService.t('ALLIANCE.LOW.SING')}-hub/:id`, alias: ['alliances/:id'] },
    ALLIANCE_OVERVIEW_PAGE: { name: 'alliance-overview', path: `${ALLIANCE_PREFIX}-:id`, alias: ['alliance/:id', `${i18nService.t('ALLIANCE.LOW.SING')}/:id`] },
    AMENDMENT_OVERVIEW_PAGE: {
        name: 'amendment-overview',
        path: `${AMENDMENT_PREFIX}-:id`,
        alias: ['amendment/:id', `${i18nService.t('AMENDMENT.LOW.SING')}/:id`]
    },
    MAIN_LAYOUT: { name: 'main', path: '/' },
    BRIEF_HUB_PAGE: { name: 'brief-hub', path: i18nService.t('BRIEF.LOW.SING'), alias: ['brief', 'briefs'] },
    BRIEF_OVERVIEW_PAGE: { name: 'brief-overview', path: `${i18nService.t('BRIEF.LOW.SING')}/:id`, alias: ['brief/:id', 'briefs/:id'] },
    CAMPAIGN_HUB_PAGE: { name: 'campaign-hub', path: i18nService.t('CAMPAIGN.LOW.SING'), alias: ['campaign', 'campaigns'] },
    CAMPAIGN_OVERVIEW_PAGE: { name: 'campaign', path: `${i18nService.t('CAMPAIGN.LOW.SING')}/:id`, alias: ['campaign/:id', 'campaigns/:id'] },
    COMPANY_HUB_PAGE: { name: 'company-hub', path: i18nService.t('COMPANY.LOW.SING'), alias: ['company'] },
    COMPANY_HUB_PAGE_BOARD: { name: 'company-hub-board', path: `${i18nService.t('COMPANY.LOW.SING')}-hub/:id`, alias: ['companies/:id'] },
    COMPANY_OVERVIEW_PAGE: { name: 'company-overview', path: `${i18nService.t('COMPANY.LOW.SING')}/:id`, alias: ['company/:id'] },
    CONTACT_HUB_PAGE: { name: 'contact-hub', path: i18nService.t('CONTACT.LOW.SING'), alias: ['contact'] },
    CONTACT_OVERVIEW_PAGE: { name: 'contact-overview', path: `${i18nService.t('CONTACT.LOW.SING')}/:id`, alias: ['contact/:id'] },
    CONFERENCE_HUB_PAGE: { name: 'conference-hub', path: i18nService.t('CONFERENCE.LOW.SING'), alias: ['conference', 'conferences'] },
    CONFERENCE_OVERVIEW_PAGE: { name: 'conference-overview', path: `${i18nService.t('CONFERENCE.LOW.SING')}/:id`, alias: ['conference/:id'] },
    DASHBOARD_HUB_PAGE: { name: 'dashboard-hub', path: i18nService.t('DASHBOARD.LOW.SING'), alias: ['dashboard'] },
    DASHBOARD_HUB_PAGE_BOARD: { name: 'dashboard-hub-board', path: `${i18nService.t('DASHBOARD.LOW.SING')}/:id`, alias: ['dashboard/:id'] },
    ERROR_PAGE: { name: 'error-page', path: '/error-page/:id?', alias: ['error/:id?'] },
    EXAMPLE_OVERVIEW_PAGE: { name: 'example-overview', path: 'example-overview' },
    EXAMPLE_HUB_PAGE: { name: 'example-hub', path: 'example-hub/:id?' },
    EVALUATION_EDITION_PAGE: { name: 'evaluation-edition', path: 'evaluation-edition/:id' },
    EVALUATION_READ_PAGE: { name: 'evaluation', path: 'evaluation/:id' },
    HOME_PAGE: { name: 'home', path: 'home' },
    LEAD_HUB_PAGE: { name: 'lead-hub', path: `${i18nService.t('LEAD.LOW.SING')}-hub`, alias: ['list'] },
    LEAD_HUB_PAGE_BOARD: { name: 'lead-hub-board', path: `${i18nService.t('LEAD.LOW.SING')}-hub/:id`, alias: ['list/:id'] },
    LEAD_OVERVIEW_PAGE: { name: 'lead-overview', path: `${LEAD_PREFIX}-:id`, alias: ['lead/:id', `${i18nService.t('LEAD.LOW.SING')}/:id`] },
    MEETING_OVERVIEW_PAGE: { name: 'meeting-overview', path: `${i18nService.t('MEETING.LOW.SING')}/:id`, alias: ['meeting/:id'] },
    MEETING_HUB_PAGE: { name: 'meeting-hub', path: `${i18nService.t('MEETING.LOW.SING')}-hub`, alias: ['meeting', 'meetings'] },
    MEETING_HUB_PAGE_BOARD: { name: 'meeting-hub-board', path: `${i18nService.t('MEETING.LOW.SING')}-hub/:id`, alias: ['meetings/:id'] },
    NETWORK_PAGE: { name: 'network', path: 'network' },
    NO_ACCESS_PAGE: { name: 'no-access', path: 'no-access/:id?' },
    OBLIGATION_OVERVIEW_PAGE: {
        name: 'obligation-overview',
        path: `${OBLIGATION_PREFIX}-:id`,
        alias: ['obligation/:id', `${i18nService.t('OBLIGATION.LOW.SING')}/:id`]
    },
    OBLIGATION_CREATION_PAGE: { name: 'obligation-creation', path: `obligation-creation/:id`, props: true },
    OBLIGATION_EDITION_PAGE: { name: 'obligation-edition', path: 'obligation-edition/:agreementId/:obligationId', props: true },
    OBLIGATION_HUB_PAGE: { name: 'obligation-hub', path: i18nService.t('OBLIGATION.LOW.SING'), alias: ['obligation', 'obligations'] },
    OBLIGATION_HUB_PAGE_BOARD: { name: 'obligation-hub-board', path: `${i18nService.t('OBLIGATION.LOW.SING')}-hub/:id`, alias: ['obligations/:id'] },
    PLATFORM_SETTINGS_PAGE: { name: 'platform-settings', path: 'platform-settings' },
    TASK_OVERVIEW_PAGE: {
        name: 'task-overview',
        path: `${TASK_PREFIX}-:id`,
        alias: ['task/:id', `${i18nService.t('TASK.LOW.SING')}/:id`]
    },
    TRIGGERING_EVENT_OVERVIEW: {
        name: 'triggering-event-overview',
        path: `${i18nService.t('TRIGGERING_EVENT.LOW.SING')}/:id`,
        alias: ['triggering-event/:id']
    }
};
